import { useState, useEffect, useMemo, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Toast } from "primereact/toast";

import useAxiosPrivate from "../hooks/useAxiosPrivate";

const Facturar = () => {
  const axiosPrivate = useAxiosPrivate();
  const toast = useRef();

  const [alumnos, setAlumnos] = useState([]);
  const [alumno, setAlumno] = useState(null);
  const [pagos, setPagos] = useState([]);
  const [selected, setSelected] = useState([]);
  const [datosFact, setDatosFact] = useState(null);

  // 🔹 cargar alumnos
  useEffect(() => {
    const load = async () => {
      const res = await axiosPrivate.get("CEUM/alumnos/listado");
      setAlumnos(res.data);
    };
    load();
  }, []);

  // 🔹 cargar pagos del alumno
  useEffect(() => {
    const loadPagos = async () => {
      if (!alumno) return;

      const res = await axiosPrivate.get(`CEUM/pagos/${alumno.Matricula}`);
      setPagos(res.data);
    };

    const loadDatosFact = async () => {
      const res = await axiosPrivate.get(`CEUM/facturacion/${alumno.Matricula}`);
      setDatosFact(res.data);
    };

    if (alumno) {
      loadPagos();
      loadDatosFact();
    }
  }, [alumno]);

  const total = useMemo(() => {
    return selected.reduce((acc, r) => acc + Number(r.total || 0), 0);
  }, [selected]);

  const generarFactura = async () => {
    if (!selected.length) {
      toast.current.show({
        severity: "warn",
        summary: "Selecciona pagos",
      });
      return;
    }

    if (!datosFact) {
      toast.current.show({
        severity: "error",
        summary: "El alumno no tiene datos de facturación",
      });
      return;
    }

    try {
      await axiosPrivate.post("CEUM/facturas/generar", {
        idPagos: selected.map(p => p.id)
      });

      toast.current.show({
        severity: "success",
        summary: "Factura generada",
      });

      setSelected([]);

    } catch (e) {
      console.error(e);
      toast.current.show({
        severity: "error",
        summary: "Error al facturar",
      });
    }
  };

  const money = (v) => `$ ${Number(v || 0).toFixed(2)}`;

  return (
    <Card title="Generar Factura">
      <Toast ref={toast} />

      {/* 🔹 Alumno */}
      <div className="flex gap-2 mb-3">
        <Dropdown
          value={alumno}
          options={alumnos}
          optionLabel="nombre_completo"
          placeholder="Selecciona alumno"
          filter
          onChange={(e) => setAlumno(e.value)}
          style={{ width: "300px" }}
        />
      </div>

      {/* 🔹 Datos fiscales */}
      {datosFact && (
        <div className="mb-3 p-3 border-1 border-round">
          <strong>{datosFact.nombre}</strong> - {datosFact.rfc}
          <br />
          Uso CFDI: {datosFact.uso_cfdi}
        </div>
      )}

      {/* 🔹 Pagos */}
      <DataTable
        value={pagos}
        selection={selected}
        onSelectionChange={(e) => setSelected(e.value)}
        dataKey="id"
        paginator
        rows={10}
      >
        <Column selectionMode="multiple" />
        <Column field="id" header="Pago" />
        <Column field="fecha" header="Fecha" />
        <Column field="metodo_pago" header="Método" />
        <Column
          header="Total"
          body={(row) => money(row.total)}
        />
      </DataTable>

      {/* 🔹 Total */}
      <div className="flex justify-content-end mt-3">
        <h3>Total: {money(total)}</h3>
      </div>

      {/* 🔹 Acción */}
      <div className="flex justify-content-end mt-3">
        <Button
          label="Generar Factura"
          icon="pi pi-file"
          onClick={generarFactura}
        />
      </div>
    </Card>
  );
};

export default Facturar;